// **********************************************************************
// This file was generated by a TAF parser!
// TAF version 2.1.7.7
// Generated from `1650859511566.jce'
// **********************************************************************
import { Taf } from "@huyafed/taf-network";

const GameRelease =  {};


GameRelease.GameMediaInfoItem = function()
{
    this.type = 0;
    this.key1 = "";
    this.value = "";
    this.startTime = 0;
    this.endTime = 0;
    this.img = "";
};
GameRelease.GameMediaInfoItem.prototype._clone = function () { return new GameRelease.GameMediaInfoItem(); }
GameRelease.GameMediaInfoItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameMediaInfoItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameMediaInfoItem.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.type);
    os.writeString(1, this.key1);
    os.writeString(2, this.value);
    os.writeInt64(3, this.startTime);
    os.writeInt64(4, this.endTime);
    os.writeString(5, this.img);
};

GameRelease.GameMediaInfoItem.prototype.readFrom = function (is)
{
    this.type= is.readInt32(0, false, this.type);
    this.key1= is.readString(1, false, this.key1);
    this.value= is.readString(2, false, this.value);
    this.startTime= is.readInt64(3, false, this.startTime);
    this.endTime= is.readInt64(4, false, this.endTime);
    this.img= is.readString(5, false, this.img);
};

GameRelease.CommentAttach = function()
{
    this.iType = 0;
    this.sContent = "";
    this.sFileMD5 = "";
};
GameRelease.CommentAttach.prototype._clone = function () { return new GameRelease.CommentAttach(); }
GameRelease.CommentAttach.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.CommentAttach.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.CommentAttach.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iType);
    os.writeString(1, this.sContent);
    os.writeString(2, this.sFileMD5);
};

GameRelease.CommentAttach.prototype.readFrom = function (is)
{
    this.iType= is.readInt32(0, false, this.iType);
    this.sContent= is.readString(1, false, this.sContent);
    this.sFileMD5= is.readString(2, false, this.sFileMD5);
};

GameRelease.WelfareActivationCode = function()
{
    this.welfareCode = "";
    this.welfarePwd = "";
};
GameRelease.WelfareActivationCode.prototype._clone = function () { return new GameRelease.WelfareActivationCode(); }
GameRelease.WelfareActivationCode.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.WelfareActivationCode.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.WelfareActivationCode.prototype.writeTo = function (os)
{
    os.writeString(0, this.welfareCode);
    os.writeString(1, this.welfarePwd);
};

GameRelease.WelfareActivationCode.prototype.readFrom = function (is)
{
    this.welfareCode= is.readString(0, false, this.welfareCode);
    this.welfarePwd= is.readString(1, false, this.welfarePwd);
};

GameRelease.GameWelfareInfoContent = function()
{
    this.contentName = "";
    this.contentImg = "";
};
GameRelease.GameWelfareInfoContent.prototype._clone = function () { return new GameRelease.GameWelfareInfoContent(); }
GameRelease.GameWelfareInfoContent.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameWelfareInfoContent.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameWelfareInfoContent.prototype.writeTo = function (os)
{
    os.writeString(0, this.contentName);
    os.writeString(1, this.contentImg);
};

GameRelease.GameWelfareInfoContent.prototype.readFrom = function (is)
{
    this.contentName= is.readString(0, false, this.contentName);
    this.contentImg= is.readString(1, false, this.contentImg);
};

GameRelease.GameInnerWelfareItem = function()
{
    this.pic = "";
    this.desc = "";
    this.num = 0;
    this.index = 0;
};
GameRelease.GameInnerWelfareItem.prototype._clone = function () { return new GameRelease.GameInnerWelfareItem(); }
GameRelease.GameInnerWelfareItem.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameInnerWelfareItem.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameInnerWelfareItem.prototype.writeTo = function (os)
{
    os.writeString(0, this.pic);
    os.writeString(1, this.desc);
    os.writeInt32(2, this.num);
    os.writeInt32(3, this.index);
};

GameRelease.GameInnerWelfareItem.prototype.readFrom = function (is)
{
    this.pic= is.readString(0, false, this.pic);
    this.desc= is.readString(1, false, this.desc);
    this.num= is.readInt32(2, false, this.num);
    this.index= is.readInt32(3, false, this.index);
};

GameRelease.ReserveDetail = function()
{
    this.id = 0;
    this.tip = "";
    this.field = "";
    this.isRequired = 0;
};
GameRelease.ReserveDetail.prototype._clone = function () { return new GameRelease.ReserveDetail(); }
GameRelease.ReserveDetail.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.ReserveDetail.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.ReserveDetail.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.id);
    os.writeString(1, this.tip);
    os.writeString(2, this.field);
    os.writeInt32(3, this.isRequired);
};

GameRelease.ReserveDetail.prototype.readFrom = function (is)
{
    this.id= is.readInt32(0, false, this.id);
    this.tip= is.readString(1, false, this.tip);
    this.field= is.readString(2, false, this.field);
    this.isRequired= is.readInt32(3, false, this.isRequired);
};

GameRelease.GameTag = function()
{
    this.tagId = 0;
    this.tagName = "";
    this.isCategory = 0;
};
GameRelease.GameTag.prototype._clone = function () { return new GameRelease.GameTag(); }
GameRelease.GameTag.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameTag.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameTag.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.tagId);
    os.writeString(1, this.tagName);
    os.writeInt32(2, this.isCategory);
};

GameRelease.GameTag.prototype.readFrom = function (is)
{
    this.tagId= is.readInt32(0, false, this.tagId);
    this.tagName= is.readString(1, false, this.tagName);
    this.isCategory= is.readInt32(2, false, this.isCategory);
};

GameRelease.GameNoticeInfo = function()
{
    this.tag = "";
    this.text = "";
    this.url = "";
};
GameRelease.GameNoticeInfo.prototype._clone = function () { return new GameRelease.GameNoticeInfo(); }
GameRelease.GameNoticeInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameNoticeInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameNoticeInfo.prototype.writeTo = function (os)
{
    os.writeString(0, this.tag);
    os.writeString(1, this.text);
    os.writeString(2, this.url);
};

GameRelease.GameNoticeInfo.prototype.readFrom = function (is)
{
    this.tag= is.readString(0, false, this.tag);
    this.text= is.readString(1, false, this.text);
    this.url= is.readString(2, false, this.url);
};

GameRelease.GameMediaInfo = function()
{
    this.liveIds = new Taf.Vector(new Taf.INT64());
    this.uids = new Taf.Vector(new Taf.INT64());
    this.videoUrl = "";
    this.items = new Taf.Vector(new GameRelease.GameMediaInfoItem());
};
GameRelease.GameMediaInfo.prototype._clone = function () { return new GameRelease.GameMediaInfo(); }
GameRelease.GameMediaInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameMediaInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameMediaInfo.prototype.writeTo = function (os)
{
    os.writeVector(0, this.liveIds);
    os.writeVector(1, this.uids);
    os.writeString(2, this.videoUrl);
    os.writeVector(3, this.items);
};

GameRelease.GameMediaInfo.prototype.readFrom = function (is)
{
    this.liveIds= is.readVector(0, false, this.liveIds);
    this.uids= is.readVector(1, false, this.uids);
    this.videoUrl= is.readString(2, false, this.videoUrl);
    this.items= is.readVector(3, false, this.items);
};

GameRelease.GameGuideReserve = function()
{
    this.iRelatedGameId = 0;
    this.iGuidReserve = 0;
    this.sGuidReserveText = "";
    this.sBtnLongText = "";
    this.sBtnShortText = "";
    this.sRelatedBtnLongText = "";
    this.sRelatedBtnShortText = "";
    this.iRelatedPostStatus = 0;
    this.iRelatedIsReverse = 0;
    this.sRelatedGameIcon = "";
    this.sRelatedGameName = "";
};
GameRelease.GameGuideReserve.prototype._clone = function () { return new GameRelease.GameGuideReserve(); }
GameRelease.GameGuideReserve.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameGuideReserve.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameGuideReserve.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iRelatedGameId);
    os.writeInt32(1, this.iGuidReserve);
    os.writeString(2, this.sGuidReserveText);
    os.writeString(3, this.sBtnLongText);
    os.writeString(4, this.sBtnShortText);
    os.writeString(5, this.sRelatedBtnLongText);
    os.writeString(6, this.sRelatedBtnShortText);
    os.writeInt32(7, this.iRelatedPostStatus);
    os.writeInt32(8, this.iRelatedIsReverse);
    os.writeString(9, this.sRelatedGameIcon);
    os.writeString(10, this.sRelatedGameName);
};

GameRelease.GameGuideReserve.prototype.readFrom = function (is)
{
    this.iRelatedGameId= is.readInt32(0, false, this.iRelatedGameId);
    this.iGuidReserve= is.readInt32(1, false, this.iGuidReserve);
    this.sGuidReserveText= is.readString(2, false, this.sGuidReserveText);
    this.sBtnLongText= is.readString(3, false, this.sBtnLongText);
    this.sBtnShortText= is.readString(4, false, this.sBtnShortText);
    this.sRelatedBtnLongText= is.readString(5, false, this.sRelatedBtnLongText);
    this.sRelatedBtnShortText= is.readString(6, false, this.sRelatedBtnShortText);
    this.iRelatedPostStatus= is.readInt32(7, false, this.iRelatedPostStatus);
    this.iRelatedIsReverse= is.readInt32(8, false, this.iRelatedIsReverse);
    this.sRelatedGameIcon= is.readString(9, false, this.sRelatedGameIcon);
    this.sRelatedGameName= is.readString(10, false, this.sRelatedGameName);
};

GameRelease.GameDynamicInfo = function()
{
    this.ms = 0;
    this.text = "";
    this.dlWndContent = "";
};
GameRelease.GameDynamicInfo.prototype._clone = function () { return new GameRelease.GameDynamicInfo(); }
GameRelease.GameDynamicInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameDynamicInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameDynamicInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.ms);
    os.writeString(1, this.text);
    os.writeString(2, this.dlWndContent);
};

GameRelease.GameDynamicInfo.prototype.readFrom = function (is)
{
    this.ms= is.readInt64(0, false, this.ms);
    this.text= is.readString(1, false, this.text);
    this.dlWndContent= is.readString(2, false, this.dlWndContent);
};

GameRelease.CommentTag = function()
{
    this.iTagId = 0;
    this.vCommentAttach = new Taf.Vector(new GameRelease.CommentAttach());
};
GameRelease.CommentTag.prototype._clone = function () { return new GameRelease.CommentTag(); }
GameRelease.CommentTag.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.CommentTag.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.CommentTag.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.iTagId);
    os.writeVector(1, this.vCommentAttach);
};

GameRelease.CommentTag.prototype.readFrom = function (is)
{
    this.iTagId= is.readInt32(0, false, this.iTagId);
    this.vCommentAttach= is.readVector(1, false, this.vCommentAttach);
};

GameRelease.GameWelfareInfo = function()
{
    this.gameId = 0;
    this.welfareId = 0;
    this.welfareName = "";
    this.welfareType = 0;
    this.welfareUsage = "";
    this.welfareIntro = "";
    this.welfareCount = 0;
    this.welfareUsedCount = 0;
    this.startTime = 0;
    this.endTime = 0;
    this.status = 0;
    this.packParam = new Taf.Map(new Taf.STRING(), new Taf.STRING());
    this.currentTime = 0;
    this.duration = 0;
    this.contents = new Taf.Vector(new GameRelease.GameWelfareInfoContent());
    this.isReceive = 0;
    this.effectiveStartTime = 0;
    this.effectiveEndTime = 0;
    this.receiveStatus = 0;
    this.activationCode = new GameRelease.WelfareActivationCode();
    this.userIfCanPick = 0;
    this.pickCountRecent = 0;
    this.onlineCount = 0;
    this.weight = 0;
    this.platform = "";
};
GameRelease.GameWelfareInfo.prototype._clone = function () { return new GameRelease.GameWelfareInfo(); }
GameRelease.GameWelfareInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameWelfareInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameWelfareInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.gameId);
    os.writeInt32(1, this.welfareId);
    os.writeString(2, this.welfareName);
    os.writeInt32(3, this.welfareType);
    os.writeString(4, this.welfareUsage);
    os.writeString(5, this.welfareIntro);
    os.writeInt32(6, this.welfareCount);
    os.writeInt32(7, this.welfareUsedCount);
    os.writeInt32(8, this.startTime);
    os.writeInt32(9, this.endTime);
    os.writeInt32(10, this.status);
    os.writeMap(11, this.packParam);
    os.writeInt32(12, this.currentTime);
    os.writeInt32(13, this.duration);
    os.writeVector(14, this.contents);
    os.writeInt32(15, this.isReceive);
    os.writeInt32(16, this.effectiveStartTime);
    os.writeInt32(17, this.effectiveEndTime);
    os.writeInt32(18, this.receiveStatus);
    os.writeStruct(19, this.activationCode);
    os.writeInt32(20, this.userIfCanPick);
    os.writeInt32(21, this.pickCountRecent);
    os.writeInt32(22, this.onlineCount);
    os.writeInt32(23, this.weight);
    os.writeString(24, this.platform);
};

GameRelease.GameWelfareInfo.prototype.readFrom = function (is)
{
    this.gameId= is.readInt32(0, false, this.gameId);
    this.welfareId= is.readInt32(1, false, this.welfareId);
    this.welfareName= is.readString(2, false, this.welfareName);
    this.welfareType= is.readInt32(3, false, this.welfareType);
    this.welfareUsage= is.readString(4, false, this.welfareUsage);
    this.welfareIntro= is.readString(5, false, this.welfareIntro);
    this.welfareCount= is.readInt32(6, false, this.welfareCount);
    this.welfareUsedCount= is.readInt32(7, false, this.welfareUsedCount);
    this.startTime= is.readInt32(8, false, this.startTime);
    this.endTime= is.readInt32(9, false, this.endTime);
    this.status= is.readInt32(10, false, this.status);
    this.packParam= is.readMap(11, false, this.packParam);
    this.currentTime= is.readInt32(12, false, this.currentTime);
    this.duration= is.readInt32(13, false, this.duration);
    this.contents= is.readVector(14, false, this.contents);
    this.isReceive= is.readInt32(15, false, this.isReceive);
    this.effectiveStartTime= is.readInt32(16, false, this.effectiveStartTime);
    this.effectiveEndTime= is.readInt32(17, false, this.effectiveEndTime);
    this.receiveStatus= is.readInt32(18, false, this.receiveStatus);
    this.activationCode= is.readStruct(19, false, this.activationCode);
    this.userIfCanPick= is.readInt32(20, false, this.userIfCanPick);
    this.pickCountRecent= is.readInt32(21, false, this.pickCountRecent);
    this.onlineCount= is.readInt32(22, false, this.onlineCount);
    this.weight= is.readInt32(23, false, this.weight);
    this.platform= is.readString(24, false, this.platform);
};

GameRelease.GameResourceInfo = function()
{
    this.gameId = 0;
    this.iosAppStoreId = "";
    this.iosDownloadUrl = "";
    this.iosVersion = "";
    this.adrPackageName = "";
    this.adrDownloadUrl = "";
    this.adrVersion = "";
    this.iosFileSize = "";
    this.adrFileSize = "";
    this.apkPermission = "";
    this.privacyPolicy = "";
    this.adrVersionCode = 0;
};
GameRelease.GameResourceInfo.prototype._clone = function () { return new GameRelease.GameResourceInfo(); }
GameRelease.GameResourceInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameResourceInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameResourceInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.gameId);
    os.writeString(1, this.iosAppStoreId);
    os.writeString(2, this.iosDownloadUrl);
    os.writeString(3, this.iosVersion);
    os.writeString(4, this.adrPackageName);
    os.writeString(5, this.adrDownloadUrl);
    os.writeString(6, this.adrVersion);
    os.writeString(7, this.iosFileSize);
    os.writeString(8, this.adrFileSize);
    os.writeString(9, this.apkPermission);
    os.writeString(10, this.privacyPolicy);
    os.writeInt64(12, this.adrVersionCode);
};

GameRelease.GameResourceInfo.prototype.readFrom = function (is)
{
    this.gameId= is.readInt32(0, false, this.gameId);
    this.iosAppStoreId= is.readString(1, false, this.iosAppStoreId);
    this.iosDownloadUrl= is.readString(2, false, this.iosDownloadUrl);
    this.iosVersion= is.readString(3, false, this.iosVersion);
    this.adrPackageName= is.readString(4, false, this.adrPackageName);
    this.adrDownloadUrl= is.readString(5, false, this.adrDownloadUrl);
    this.adrVersion= is.readString(6, false, this.adrVersion);
    this.iosFileSize= is.readString(7, false, this.iosFileSize);
    this.adrFileSize= is.readString(8, false, this.adrFileSize);
    this.apkPermission= is.readString(9, false, this.apkPermission);
    this.privacyPolicy= is.readString(10, false, this.privacyPolicy);
    this.adrVersionCode= is.readInt64(12, false, this.adrVersionCode);
};

GameRelease.GameInnerWelfare = function()
{
    this.id = 0;
    this.gameId = 0;
    this.type = 0;
    this.welfareName = "";
    this.startTime = 0;
    this.endTime = 0;
    this.giftPic = 0;
    this.items = new Taf.Vector(new GameRelease.GameInnerWelfareItem());
};
GameRelease.GameInnerWelfare.prototype._clone = function () { return new GameRelease.GameInnerWelfare(); }
GameRelease.GameInnerWelfare.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameInnerWelfare.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameInnerWelfare.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.id);
    os.writeInt32(1, this.gameId);
    os.writeInt32(2, this.type);
    os.writeString(3, this.welfareName);
    os.writeInt32(4, this.startTime);
    os.writeInt32(5, this.endTime);
    os.writeInt32(6, this.giftPic);
    os.writeVector(7, this.items);
};

GameRelease.GameInnerWelfare.prototype.readFrom = function (is)
{
    this.id= is.readInt64(0, false, this.id);
    this.gameId= is.readInt32(1, false, this.gameId);
    this.type= is.readInt32(2, false, this.type);
    this.welfareName= is.readString(3, false, this.welfareName);
    this.startTime= is.readInt32(4, false, this.startTime);
    this.endTime= is.readInt32(5, false, this.endTime);
    this.giftPic= is.readInt32(6, false, this.giftPic);
    this.items= is.readVector(7, false, this.items);
};

GameRelease.GameBaseInfo = function()
{
    this.gameId = 0;
    this.gameName = "";
    this.gameIcon = "";
    this.gameScore = "";
    this.gameTags = new Taf.Vector(new GameRelease.GameTag());
    this.isIos = 0;
    this.isAndroid = 0;
    this.gameDownloadCount = 0;
    this.gamePublisher = "";
    this.gameDeveloper = "";
    this.gameBrief = "";
    this.gameIntro = "";
    this.gameLatestReleases = "";
    this.gameLanguages = "";
    this.gameEnvironments = "";
    this.gameScreenshots = "";
    this.gameVideos = "";
    this.vid = "";
    this.commentId = "";
    this.isHorizontalScreen = 0;
    this.gameVideoScreenshot = "";
    this.gameVideoDuration = "";
    this.postStatus = 0;
    this.reserveNum = 0;
    this.isReserve = 0;
    this.reserveInfo = "";
    this.reserveDetails = new Taf.Vector(new GameRelease.ReserveDetail());
    this.noticeText = "";
    this.noticeUrl = "";
    this.mediaInfo = new GameRelease.GameMediaInfo();
    this.dynamicInfo = new GameRelease.GameDynamicInfo();
    this.noticeInfo = new Taf.Vector(new GameRelease.GameNoticeInfo());
    this.tip = "";
    this.developerWords = "";
    this.recGame = 0;
    this.publishTime = 0;
    this.tGuideReserve = new GameRelease.GameGuideReserve();
    this.joint = 0;
    this.guideBtnJumpUrl = "";
    this.guideBtnText = "";
};
GameRelease.GameBaseInfo.prototype._clone = function () { return new GameRelease.GameBaseInfo(); }
GameRelease.GameBaseInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameBaseInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameBaseInfo.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.gameId);
    os.writeString(1, this.gameName);
    os.writeString(2, this.gameIcon);
    os.writeString(3, this.gameScore);
    os.writeVector(4, this.gameTags);
    os.writeInt32(5, this.isIos);
    os.writeInt32(6, this.isAndroid);
    os.writeInt32(7, this.gameDownloadCount);
    os.writeString(8, this.gamePublisher);
    os.writeString(9, this.gameDeveloper);
    os.writeString(10, this.gameBrief);
    os.writeString(11, this.gameIntro);
    os.writeString(12, this.gameLatestReleases);
    os.writeString(13, this.gameLanguages);
    os.writeString(14, this.gameEnvironments);
    os.writeString(15, this.gameScreenshots);
    os.writeString(16, this.gameVideos);
    os.writeString(17, this.vid);
    os.writeString(18, this.commentId);
    os.writeInt32(19, this.isHorizontalScreen);
    os.writeString(20, this.gameVideoScreenshot);
    os.writeString(21, this.gameVideoDuration);
    os.writeInt32(22, this.postStatus);
    os.writeInt32(23, this.reserveNum);
    os.writeInt32(24, this.isReserve);
    os.writeString(25, this.reserveInfo);
    os.writeVector(26, this.reserveDetails);
    os.writeString(27, this.noticeText);
    os.writeString(28, this.noticeUrl);
    os.writeStruct(29, this.mediaInfo);
    os.writeStruct(30, this.dynamicInfo);
    os.writeVector(31, this.noticeInfo);
    os.writeString(32, this.tip);
    os.writeString(33, this.developerWords);
    os.writeInt32(34, this.recGame);
    os.writeInt32(35, this.publishTime);
    os.writeStruct(36, this.tGuideReserve);
    os.writeInt32(37, this.joint);
    os.writeString(38, this.guideBtnJumpUrl);
    os.writeString(39, this.guideBtnText);
};

GameRelease.GameBaseInfo.prototype.readFrom = function (is)
{
    this.gameId= is.readInt32(0, false, this.gameId);
    this.gameName= is.readString(1, false, this.gameName);
    this.gameIcon= is.readString(2, false, this.gameIcon);
    this.gameScore= is.readString(3, false, this.gameScore);
    this.gameTags= is.readVector(4, false, this.gameTags);
    this.isIos= is.readInt32(5, false, this.isIos);
    this.isAndroid= is.readInt32(6, false, this.isAndroid);
    this.gameDownloadCount= is.readInt32(7, false, this.gameDownloadCount);
    this.gamePublisher= is.readString(8, false, this.gamePublisher);
    this.gameDeveloper= is.readString(9, false, this.gameDeveloper);
    this.gameBrief= is.readString(10, false, this.gameBrief);
    this.gameIntro= is.readString(11, false, this.gameIntro);
    this.gameLatestReleases= is.readString(12, false, this.gameLatestReleases);
    this.gameLanguages= is.readString(13, false, this.gameLanguages);
    this.gameEnvironments= is.readString(14, false, this.gameEnvironments);
    this.gameScreenshots= is.readString(15, false, this.gameScreenshots);
    this.gameVideos= is.readString(16, false, this.gameVideos);
    this.vid= is.readString(17, false, this.vid);
    this.commentId= is.readString(18, false, this.commentId);
    this.isHorizontalScreen= is.readInt32(19, false, this.isHorizontalScreen);
    this.gameVideoScreenshot= is.readString(20, false, this.gameVideoScreenshot);
    this.gameVideoDuration= is.readString(21, false, this.gameVideoDuration);
    this.postStatus= is.readInt32(22, false, this.postStatus);
    this.reserveNum= is.readInt32(23, false, this.reserveNum);
    this.isReserve= is.readInt32(24, false, this.isReserve);
    this.reserveInfo= is.readString(25, false, this.reserveInfo);
    this.reserveDetails= is.readVector(26, false, this.reserveDetails);
    this.noticeText= is.readString(27, false, this.noticeText);
    this.noticeUrl= is.readString(28, false, this.noticeUrl);
    this.mediaInfo= is.readStruct(29, false, this.mediaInfo);
    this.dynamicInfo= is.readStruct(30, false, this.dynamicInfo);
    this.noticeInfo= is.readVector(31, false, this.noticeInfo);
    this.tip= is.readString(32, false, this.tip);
    this.developerWords= is.readString(33, false, this.developerWords);
    this.recGame= is.readInt32(34, false, this.recGame);
    this.publishTime= is.readInt32(35, false, this.publishTime);
    this.tGuideReserve= is.readStruct(36, false, this.tGuideReserve);
    this.joint= is.readInt32(37, false, this.joint);
    this.guideBtnJumpUrl= is.readString(38, false, this.guideBtnJumpUrl);
    this.guideBtnText= is.readString(39, false, this.guideBtnText);
};

GameRelease.SimpleComment = function()
{
    this.lCommentId = 0;
    this.lParentId = 0;
    this.lUid = 0;
    this.sNickName = "";
    this.sAvatar = "";
    this.sContent = "";
    this.iLikeCount = 0;
    this.iShareCount = 0;
    this.iStatus = 0;
    this.lTime = 0;
    this.iSubCommentCount = 0;
    this.vSubComment = new Taf.Vector(GameRelease.SimpleComment);
    this.vTag = new Taf.Vector(new GameRelease.CommentTag());
    this.lReplyToComId = 0;
    this.lReplyToUid = 0;
    this.sReplyToNickName = "";
    this.iOnwerOpt = 0;
    this.iOpt = 0;
};
GameRelease.SimpleComment.prototype._clone = function () { return new GameRelease.SimpleComment(); }
GameRelease.SimpleComment.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.SimpleComment.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.SimpleComment.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lCommentId);
    os.writeInt64(1, this.lParentId);
    os.writeInt64(2, this.lUid);
    os.writeString(3, this.sNickName);
    os.writeString(4, this.sAvatar);
    os.writeString(5, this.sContent);
    os.writeInt32(6, this.iLikeCount);
    os.writeInt32(7, this.iShareCount);
    os.writeInt32(8, this.iStatus);
    os.writeInt64(9, this.lTime);
    os.writeInt32(10, this.iSubCommentCount);
    os.writeVector(11, this.vSubComment);
    os.writeVector(12, this.vTag);
    os.writeInt64(13, this.lReplyToComId);
    os.writeInt64(14, this.lReplyToUid);
    os.writeString(15, this.sReplyToNickName);
    os.writeInt32(16, this.iOnwerOpt);
    os.writeInt32(17, this.iOpt);
};

GameRelease.SimpleComment.prototype.readFrom = function (is)
{
    this.lCommentId= is.readInt64(0, false, this.lCommentId);
    this.lParentId= is.readInt64(1, false, this.lParentId);
    this.lUid= is.readInt64(2, false, this.lUid);
    this.sNickName= is.readString(3, false, this.sNickName);
    this.sAvatar= is.readString(4, false, this.sAvatar);
    this.sContent= is.readString(5, false, this.sContent);
    this.iLikeCount= is.readInt32(6, false, this.iLikeCount);
    this.iShareCount= is.readInt32(7, false, this.iShareCount);
    this.iStatus= is.readInt32(8, false, this.iStatus);
    this.lTime= is.readInt64(9, false, this.lTime);
    this.iSubCommentCount= is.readInt32(10, false, this.iSubCommentCount);
    this.vSubComment= is.readVector(11, false, this.vSubComment);
    this.vTag= is.readVector(12, false, this.vTag);
    this.lReplyToComId= is.readInt64(13, false, this.lReplyToComId);
    this.lReplyToUid= is.readInt64(14, false, this.lReplyToUid);
    this.sReplyToNickName= is.readString(15, false, this.sReplyToNickName);
    this.iOnwerOpt= is.readInt32(16, false, this.iOnwerOpt);
    this.iOpt= is.readInt32(17, false, this.iOpt);
};

GameRelease.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sDeviceInfo = "";
};
GameRelease.UserId.prototype._clone = function () { return new GameRelease.UserId(); }
GameRelease.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sDeviceInfo);
};

GameRelease.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sDeviceInfo= is.readString(6, false, this.sDeviceInfo);
};

GameRelease.LiveRoomInfo = function()
{
    this.anchorUid = 0;
    this.nick = "";
    this.avatar = "";
    this.popularityValue = 0;
    this.cover = "";
    this.liveJumpUrl = "";
    this.liveRoomDesc = "";
    this.anchorTag = new Taf.Vector(new Taf.STRING());
    this.gid = 0;
};
GameRelease.LiveRoomInfo.prototype._clone = function () { return new GameRelease.LiveRoomInfo(); }
GameRelease.LiveRoomInfo.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.LiveRoomInfo.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.LiveRoomInfo.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.anchorUid);
    os.writeString(1, this.nick);
    os.writeString(2, this.avatar);
    os.writeInt32(3, this.popularityValue);
    os.writeString(4, this.cover);
    os.writeString(5, this.liveJumpUrl);
    os.writeString(6, this.liveRoomDesc);
    os.writeVector(7, this.anchorTag);
    os.writeInt32(8, this.gid);
};

GameRelease.LiveRoomInfo.prototype.readFrom = function (is)
{
    this.anchorUid= is.readInt64(0, false, this.anchorUid);
    this.nick= is.readString(1, false, this.nick);
    this.avatar= is.readString(2, false, this.avatar);
    this.popularityValue= is.readInt32(3, false, this.popularityValue);
    this.cover= is.readString(4, false, this.cover);
    this.liveJumpUrl= is.readString(5, false, this.liveJumpUrl);
    this.liveRoomDesc= is.readString(6, false, this.liveRoomDesc);
    this.anchorTag= is.readVector(7, false, this.anchorTag);
    this.gid= is.readInt32(8, false, this.gid);
};

GameRelease.GameCeterResponse = function()
{
    this.res = 0;
    this.msg = "";
};
GameRelease.GameCeterResponse.prototype._clone = function () { return new GameRelease.GameCeterResponse(); }
GameRelease.GameCeterResponse.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameCeterResponse.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameCeterResponse.prototype.writeTo = function (os)
{
    os.writeInt32(0, this.res);
    os.writeString(1, this.msg);
};

GameRelease.GameCeterResponse.prototype.readFrom = function (is)
{
    this.res= is.readInt32(0, false, this.res);
    this.msg= is.readString(1, false, this.msg);
};

export const HUYA =  {};


HUYA.UserId = function()
{
    this.lUid = 0;
    this.sGuid = "";
    this.sToken = "";
    this.sHuYaUA = "";
    this.sCookie = "";
    this.iTokenType = 0;
    this.sDeviceInfo = "";
};
HUYA.UserId.prototype._clone = function () { return new HUYA.UserId(); }
HUYA.UserId.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
HUYA.UserId.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

HUYA.UserId.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.lUid);
    os.writeString(1, this.sGuid);
    os.writeString(2, this.sToken);
    os.writeString(3, this.sHuYaUA);
    os.writeString(4, this.sCookie);
    os.writeInt32(5, this.iTokenType);
    os.writeString(6, this.sDeviceInfo);
};

HUYA.UserId.prototype.readFrom = function (is)
{
    this.lUid= is.readInt64(0, false, this.lUid);
    this.sGuid= is.readString(1, false, this.sGuid);
    this.sToken= is.readString(2, false, this.sToken);
    this.sHuYaUA= is.readString(3, false, this.sHuYaUA);
    this.sCookie= is.readString(4, false, this.sCookie);
    this.iTokenType= is.readInt32(5, false, this.iTokenType);
    this.sDeviceInfo= is.readString(6, false, this.sDeviceInfo);
};


GameRelease.GameDetail = function()
{
    this.gameBaseInfo = new GameRelease.GameBaseInfo();
    this.gameResourceInfo = new GameRelease.GameResourceInfo();
    this.gameWelfareInfoList = new Taf.Vector(new GameRelease.GameWelfareInfo());
    this.showOrder = new Taf.Vector(new Taf.INT32());
    this.categoryId = 0;
    this.configText = "";
    this.sourceId = 0;
    this.circleId = 0;
    this.circleTabId = 0;
    this.innerWelfares = new Taf.Vector(new GameRelease.GameInnerWelfare());
    this.canReceivedCouponCnt = 0;
};
GameRelease.GameDetail.prototype._clone = function () { return new GameRelease.GameDetail(); }
GameRelease.GameDetail.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameDetail.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameDetail.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.gameBaseInfo);
    os.writeStruct(1, this.gameResourceInfo);
    os.writeVector(2, this.gameWelfareInfoList);
    os.writeVector(3, this.showOrder);
    os.writeInt32(4, this.categoryId);
    os.writeString(5, this.configText);
    os.writeInt32(6, this.sourceId);
    os.writeInt32(7, this.circleId);
    os.writeInt32(8, this.circleTabId);
    os.writeVector(9, this.innerWelfares);
    os.writeInt32(10, this.canReceivedCouponCnt);
};

GameRelease.GameDetail.prototype.readFrom = function (is)
{
    this.gameBaseInfo= is.readStruct(0, false, this.gameBaseInfo);
    this.gameResourceInfo= is.readStruct(1, false, this.gameResourceInfo);
    this.gameWelfareInfoList= is.readVector(2, false, this.gameWelfareInfoList);
    this.showOrder= is.readVector(3, false, this.showOrder);
    this.categoryId= is.readInt32(4, false, this.categoryId);
    this.configText= is.readString(5, false, this.configText);
    this.sourceId= is.readInt32(6, false, this.sourceId);
    this.circleId= is.readInt32(7, false, this.circleId);
    this.circleTabId= is.readInt32(8, false, this.circleTabId);
    this.innerWelfares= is.readVector(9, false, this.innerWelfares);
    this.canReceivedCouponCnt= is.readInt32(10, false, this.canReceivedCouponCnt);
};

GameRelease.GetSimpleCommentRsp = function()
{
    this.sMessage = "";
    this.vComment = new Taf.Vector(new GameRelease.SimpleComment());
    this.iHasMore = 0;
    this.iTotal = 0;
};
GameRelease.GetSimpleCommentRsp.prototype._clone = function () { return new GameRelease.GetSimpleCommentRsp(); }
GameRelease.GetSimpleCommentRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GetSimpleCommentRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GetSimpleCommentRsp.prototype.writeTo = function (os)
{
    os.writeString(0, this.sMessage);
    os.writeVector(1, this.vComment);
    os.writeInt32(2, this.iHasMore);
    os.writeInt64(3, this.iTotal);
};

GameRelease.GetSimpleCommentRsp.prototype.readFrom = function (is)
{
    this.sMessage= is.readString(0, false, this.sMessage);
    this.vComment= is.readVector(1, false, this.vComment);
    this.iHasMore= is.readInt32(2, false, this.iHasMore);
    this.iTotal= is.readInt64(3, false, this.iTotal);
};

GameRelease.GetSimpleCommentWhitTopReq = function()
{
    this.tId = new GameRelease.UserId();
    this.iAppId = 0;
    this.sTopicId = "";
    this.iIndex = 0;
    this.iSize = 0;
    this.iListType = 0;
    this.topId = 0;
};
GameRelease.GetSimpleCommentWhitTopReq.prototype._clone = function () { return new GameRelease.GetSimpleCommentWhitTopReq(); }
GameRelease.GetSimpleCommentWhitTopReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GetSimpleCommentWhitTopReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GetSimpleCommentWhitTopReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt32(1, this.iAppId);
    os.writeString(2, this.sTopicId);
    os.writeInt32(3, this.iIndex);
    os.writeInt32(4, this.iSize);
    os.writeInt32(5, this.iListType);
    os.writeInt64(6, this.topId);
};

GameRelease.GetSimpleCommentWhitTopReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.iAppId= is.readInt32(1, false, this.iAppId);
    this.sTopicId= is.readString(2, false, this.sTopicId);
    this.iIndex= is.readInt32(3, false, this.iIndex);
    this.iSize= is.readInt32(4, false, this.iSize);
    this.iListType= is.readInt32(5, false, this.iListType);
    this.topId= is.readInt64(6, false, this.topId);
};

GameRelease.GetGidLiveRoomRsp = function()
{
    this.response = new GameRelease.GameCeterResponse();
    this.liveRoomList = new Taf.Vector(new GameRelease.LiveRoomInfo());
    this.liveRoomCount = 0;
};
GameRelease.GetGidLiveRoomRsp.prototype._clone = function () { return new GameRelease.GetGidLiveRoomRsp(); }
GameRelease.GetGidLiveRoomRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GetGidLiveRoomRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GetGidLiveRoomRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.response);
    os.writeVector(1, this.liveRoomList);
    os.writeInt32(2, this.liveRoomCount);
};

GameRelease.GetGidLiveRoomRsp.prototype.readFrom = function (is)
{
    this.response= is.readStruct(0, false, this.response);
    this.liveRoomList= is.readVector(1, false, this.liveRoomList);
    this.liveRoomCount= is.readInt32(2, false, this.liveRoomCount);
};

GameRelease.GetGidLiveRoomReq = function()
{
    this.tId = new HUYA.UserId();
    this.gid = 0;
    this.page = 0;
    this.size = 0;
};
GameRelease.GetGidLiveRoomReq.prototype._clone = function () { return new GameRelease.GetGidLiveRoomReq(); }
GameRelease.GetGidLiveRoomReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GetGidLiveRoomReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GetGidLiveRoomReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt32(1, this.gid);
    os.writeInt32(2, this.page);
    os.writeInt32(3, this.size);
};

GameRelease.GetGidLiveRoomReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.gid= is.readInt32(1, false, this.gid);
    this.page= is.readInt32(2, false, this.page);
    this.size= is.readInt32(3, false, this.size);
};

GameRelease.GameDetailResp = function()
{
    this.response = new GameRelease.GameCeterResponse();
    this.gameDetail = new GameRelease.GameDetail();
};
GameRelease.GameDetailResp.prototype._clone = function () { return new GameRelease.GameDetailResp(); }
GameRelease.GameDetailResp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameDetailResp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameDetailResp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.response);
    os.writeStruct(1, this.gameDetail);
};

GameRelease.GameDetailResp.prototype.readFrom = function (is)
{
    this.response= is.readStruct(0, false, this.response);
    this.gameDetail= is.readStruct(1, false, this.gameDetail);
};

GameRelease.GameDetailReq = function()
{
    this.tId = new HUYA.UserId();
    this.gameId = 0;
    this.chId = 0;
};
GameRelease.GameDetailReq.prototype._clone = function () { return new GameRelease.GameDetailReq(); }
GameRelease.GameDetailReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameDetailReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameDetailReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt32(1, this.gameId);
    os.writeInt32(2, this.chId);
};

GameRelease.GameDetailReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.gameId= is.readInt32(1, false, this.gameId);
    this.chId= is.readInt32(2, false, this.chId);
};



GameRelease.GameCoupon = function()
{
    this.couponId = 0;
    this.recordId = 0;
    this.gameId = 0;
    this.couponName = "";
    this.couponDesc = "";
    this.couponUsePreCondition = "";
    this.couponUuid = "";
    this.couponCode = "";
    this.serial = "";
    this.couponType = 0;
    this.couponMinPrice = 0;
    this.couponFavour = 0;
    this.winTime = 0;
    this.startTime = 0;
    this.endTime = 0;
    this.effectiveStartTime = 0;
    this.effectiveEndTime = 0;
    this.useStatus = 0;
    this.ifCanUse = 0;
    this.location = "";
    this.totalCount = 0;
    this.leavingCount = 0;
    this.useLifespane = 0;
    this.gameName = "";
    this.canotUseReason = "";
};
GameRelease.GameCoupon.prototype._clone = function () { return new GameRelease.GameCoupon(); }
GameRelease.GameCoupon.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GameCoupon.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GameCoupon.prototype.writeTo = function (os)
{
    os.writeInt64(0, this.couponId);
    os.writeInt64(1, this.recordId);
    os.writeInt32(2, this.gameId);
    os.writeString(3, this.couponName);
    os.writeString(4, this.couponDesc);
    os.writeString(5, this.couponUsePreCondition);
    os.writeString(6, this.couponUuid);
    os.writeString(7, this.couponCode);
    os.writeString(8, this.serial);
    os.writeInt32(9, this.couponType);
    os.writeInt32(10, this.couponMinPrice);
    os.writeInt32(11, this.couponFavour);
    os.writeInt64(12, this.winTime);
    os.writeInt64(13, this.startTime);
    os.writeInt64(14, this.endTime);
    os.writeInt64(15, this.effectiveStartTime);
    os.writeInt64(16, this.effectiveEndTime);
    os.writeInt32(17, this.useStatus);
    os.writeInt32(18, this.ifCanUse);
    os.writeString(19, this.location);
    os.writeInt32(20, this.totalCount);
    os.writeInt32(21, this.leavingCount);
    os.writeInt32(22, this.useLifespane);
    os.writeString(23, this.gameName);
    os.writeString(24, this.canotUseReason);
};

GameRelease.GameCoupon.prototype.readFrom = function (is)
{
    this.couponId= is.readInt64(0, false, this.couponId);
    this.recordId= is.readInt64(1, false, this.recordId);
    this.gameId= is.readInt32(2, false, this.gameId);
    this.couponName= is.readString(3, false, this.couponName);
    this.couponDesc= is.readString(4, false, this.couponDesc);
    this.couponUsePreCondition= is.readString(5, false, this.couponUsePreCondition);
    this.couponUuid= is.readString(6, false, this.couponUuid);
    this.couponCode= is.readString(7, false, this.couponCode);
    this.serial= is.readString(8, false, this.serial);
    this.couponType= is.readInt32(9, false, this.couponType);
    this.couponMinPrice= is.readInt32(10, false, this.couponMinPrice);
    this.couponFavour= is.readInt32(11, false, this.couponFavour);
    this.winTime= is.readInt64(12, false, this.winTime);
    this.startTime= is.readInt64(13, false, this.startTime);
    this.endTime= is.readInt64(14, false, this.endTime);
    this.effectiveStartTime= is.readInt64(15, false, this.effectiveStartTime);
    this.effectiveEndTime= is.readInt64(16, false, this.effectiveEndTime);
    this.useStatus= is.readInt32(17, false, this.useStatus);
    this.ifCanUse= is.readInt32(18, false, this.ifCanUse);
    this.location= is.readString(19, false, this.location);
    this.totalCount= is.readInt32(20, false, this.totalCount);
    this.leavingCount= is.readInt32(21, false, this.leavingCount);
    this.useLifespane= is.readInt32(22, false, this.useLifespane);
    this.gameName= is.readString(23, false, this.gameName);
    this.canotUseReason= is.readString(24, false, this.canotUseReason);
};


GameRelease.GetGameCouponInfoRsp = function()
{
    this.response = new GameRelease.GameCeterResponse();
    this.coupons = new Taf.Vector(new GameRelease.GameCoupon());
    this.canReceivedCount = 0;
};
GameRelease.GetGameCouponInfoRsp.prototype._clone = function () { return new GameRelease.GetGameCouponInfoRsp(); }
GameRelease.GetGameCouponInfoRsp.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GetGameCouponInfoRsp.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GetGameCouponInfoRsp.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.response);
    os.writeVector(1, this.coupons);
    os.writeInt32(2, this.canReceivedCount);
};

GameRelease.GetGameCouponInfoRsp.prototype.readFrom = function (is)
{
    this.response= is.readStruct(0, false, this.response);
    this.coupons= is.readVector(1, false, this.coupons);
    this.canReceivedCount= is.readInt32(2, false, this.canReceivedCount);
};

GameRelease.GetGameCouponInfoReq = function()
{
    this.tId = new HUYA.UserId();
    this.gameId = 0;
    this.couponUUIDs = new Taf.Vector(new Taf.STRING());
    this.from = "";
};
GameRelease.GetGameCouponInfoReq.prototype._clone = function () { return new GameRelease.GetGameCouponInfoReq(); }
GameRelease.GetGameCouponInfoReq.prototype._write = function (os, tag, value) { os.writeStruct(tag, value); }
GameRelease.GetGameCouponInfoReq.prototype._read  = function (is, tag, def) { return is.readStruct(tag, true, def); }

GameRelease.GetGameCouponInfoReq.prototype.writeTo = function (os)
{
    os.writeStruct(0, this.tId);
    os.writeInt32(1, this.gameId);
    os.writeVector(2, this.couponUUIDs);
    os.writeString(3, this.from);
};

GameRelease.GetGameCouponInfoReq.prototype.readFrom = function (is)
{
    this.tId= is.readStruct(0, false, this.tId);
    this.gameId= is.readInt32(1, false, this.gameId);
    this.couponUUIDs= is.readVector(2, false, this.couponUUIDs);
    this.from= is.readString(3, false, this.from);
};

export default GameRelease;